function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import { FormattedMessage } from 'react-intl';
import { useAction } from 'hooks';
import Modal from 'components/Modal';
import Button from 'components/Form/Button';
import App from 'modules/App';
import * as actions from '../../actions';
import * as constants from '../../constants';
import * as selectors from '../../selectors';
import messages from '../../messages';
import OrganizationMembershipModalBox from '../OrganizationMembershipModalBox';
const Actions = ({ adminOrganizationMembership, organizationMembership, onClose })=>{
    const isInProgress = useSelector(selectors.isResendInvitationInProgress);
    const prevIsInProgressRef = useRef(isInProgress);
    const hasErrors = useSelector(selectors.hasResendInvitationErrors);
    const onSubmit = useAction(actions.resendInvitation, organizationMembership, adminOrganizationMembership);
    useEffect(()=>{
        if (prevIsInProgressRef.current !== isInProgress) {
            if (!isInProgress && !hasErrors) {
                onClose();
            }
            prevIsInProgressRef.current = isInProgress;
        }
    }, [
        isInProgress
    ]);
    return /*#__PURE__*/ _jsxs("div", {
        className: "row",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: App.messages.buttons.cancel,
                    className: "btn--block",
                    isDisabled: isInProgress,
                    onClick: onClose
                })
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "col-6",
                children: /*#__PURE__*/ _jsx(Button, {
                    styleModifier: "primary",
                    labelMessage: messages.buttons.resendInvitation,
                    className: "btn--block btn--filled",
                    isInProgress: isInProgress,
                    onClick: onSubmit
                })
            })
        ]
    });
};
const ResendInvitationModal = ({ adminOrganizationMembership, organizationMembership, openModalId, onClose })=>/*#__PURE__*/ _jsxs(Modal, {
        modalId: constants.RESEND_INVITATION_MODAL,
        openModalId: openModalId,
        headerMessage: messages.headers.resendInvitation,
        onClose: onClose,
        children: [
            /*#__PURE__*/ _jsx("p", {
                className: "text--paragraph mb-7",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.intros.resendInvitation))
            }),
            /*#__PURE__*/ _jsx(OrganizationMembershipModalBox, {
                organizationMembership: organizationMembership
            }),
            /*#__PURE__*/ _jsx(Actions, {
                adminOrganizationMembership: adminOrganizationMembership,
                organizationMembership: organizationMembership,
                onClose: onClose
            })
        ]
    });
export default ResendInvitationModal;
